module.exports = __webpack_public_path__ + "img/location_turnOff.8e6ded8e.svg";